// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import router from './router'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

// import baidutongji from './baidutongji/baidutongji.js'
// 手机调试
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole

// 剪切
import VueClipboards from 'vue-clipboards'
import SlideVerify from 'vue-monoplasty-slide-verify';

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// css样式文件
import './assets/css/export.scss'
Vue.use(SlideVerify);

Vue.use(MintUI)
// Vue.use(ElementUI);
Vue.use(VueClipboards)
Vue.config.productionTip = false



// let vConsole = new VConsole() // 初始化

var fundebug = require('fundebug-javascript');
fundebug.apikey = '408df2b9d51d16677f2936fa8ecf14121980c189b6ab2d48b54ce3e8721f3c90';

function formatComponentName (vm) {
  if (vm.$root === vm) return 'root';

  var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');
}

Vue.config.errorHandler = function (err, vm, info) {
  var componentName = formatComponentName(vm);
  var propsData = vm.$options && vm.$options.propsData;

  fundebug.notifyError(err,
  {
      metaData:
      {
          componentName: componentName,
          propsData: propsData,
          info: info
      }
   });
};
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
/* 百度统计 */





// WEBPACK FOOTER //
// ./src/main.js